// Central site configuration for RCPS Terrassement
export const SITE = {
    name: "RCPS Terrassement",
    tagline: "Terrassement, démolition et génie civil à Genève",
    address: {
        street: "Chemin du Pré-Fleuri 3",
        zip: "1228",
        city: "Plan-les-Ouates",
        country: "Suisse",
    },
    phone: "076 682 30 32",
    phoneTel: "+41766823032",
    phone2: "079 644 10 58",
    phone2Tel: "+41796441058",
    email: "contact@rcps-terrassement.ch",
    facebook: "https://www.facebook.com/profile.php?id=61589632169384",
    hours: [
        { day: "Lundi – Vendredi", value: "07h30 – 18h00" },
        { day: "Samedi", value: "Sur rendez-vous" },
        { day: "Dimanche", value: "Fermé" },
    ],
    logos: {
        blue: "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/s4psxvxc_Logo%20principal%20bleu%20-%20Grande.png",
        white: "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/qdb70d00_Logo%20principal%20blanc%20-%20Grande.png",
        iconBlue: "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/x8ypnj1c_Icone%20bleu%20-%20Grande.png",
        iconWhite: "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/5gkcab4l_Icone%20blanc%20-%20Grande.png",
    },
    legal: {
        mentions: "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/97jpu3l2_Mentions%20le%CC%81gales.pdf",
        privacy: "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/ewkj2vnw_Politique%20de%20confidentialite%CC%81.pdf",
        cgv: "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/r0qyb031_CGV.pdf",
    },
};

export const SERVICES = [
    {
        slug: "terrassement",
        title: "Terrassement",
        short: "Fouilles, excavation, décaissement, nivellement, remblaiement, préparation de terrain et évacuation des matériaux.",
        description:
            "Préparation de plateformes, fouilles, décaissement, remblaiement et évacuation des terres pour villas, immeubles et infrastructures.",
        icon: "Shovel",
        image:
            "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/6coeh1e9_Terrassement%20-%20Grande.jpeg",
    },
    {
        slug: "demolition-deconstruction",
        title: "Démolition & déconstruction",
        short: "Démolition partielle, déconstruction d’ouvrages, retrait d’éléments béton, tri des matériaux et évacuation des gravats.",
        description:
            "Démolition d’ouvrages, tri des matériaux, gestion des gravats et sécurisation complète du chantier.",
        icon: "Hammer",
        image:
            "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/49pwgc58_De%CC%81molition%20-%20Grande%20-%20Grande.jpeg",
    },
    {
        slug: "genie-civil-voirie-enrobes",
        title: "Génie civil, voirie & enrobés",
        short: "Accès, parkings, réseaux enterrés, canalisations, bordures, surfaces carrossables, préparation de fonds et revêtements bitumineux.",
        description:
            "Création et réfection d’accès, chemins, parkings, canalisations, raccordements, ouvrages béton, pose et réfection d’enrobés.",
        icon: "HardHat",
        image:
            "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/hhsqh0qq_Ge%CC%81nie%20civil%20et%20enrobe%CC%81s%20-%20Grande.jpeg",
    },
    {
        slug: "amenagements-exterieurs-enrochement",
        title: "Aménagements extérieurs & enrochement",
        short: "Cours, allées, accès extérieurs, plateformes, talus, soutènements, stabilisation de terrain et enrochement décoratif ou technique.",
        description:
            "Aménagements sur mesure, enrochement décoratif ou de soutènement, stabilisation de terrain et intégration paysagère.",
        icon: "Mountain",
        image:
            "https://customer-assets.emergentagent.com/job_elated-beaver-5/artifacts/7n5nyyj1_Ame%CC%81nagements%20exte%CC%81rieurs%20-%20Grande%20-%20Grande.jpeg",
    },
];

export const ZONES = [
    { name: "Genève", desc: "Ville et canton — secteurs urbain et périphérique." },
    { name: "Plan-les-Ouates", desc: "Notre commune d’attache — intervention rapide." },
    { name: "Carouge", desc: "Villas, immeubles et espaces publics." },
    { name: "Lancy", desc: "Chantiers résidentiels et accès." },
    { name: "Vernier", desc: "Terrassement, voirie et enrobés." },
    { name: "Meyrin", desc: "Projets d’infrastructure et accès." },
    { name: "Onex", desc: "Aménagements extérieurs et cours." },
    { name: "Grand-Saconnex", desc: "Réseaux, raccordements, enrobés." },
    { name: "Nyon & La Côte", desc: "Vaud — selon projets." },
    { name: "Lausanne", desc: "Suisse romande — projets spécifiques." },
];

export const REASSURANCE = [
    { title: "Entreprise locale", desc: "Basée à Plan-les-Ouates, RCPS Terrassement intervient à Genève, dans le canton de Genève et dans toute la Suisse romande." },
    { title: "Devis personnalisé", desc: "Chaque demande est étudiée selon la nature du chantier, les accès, les volumes, les matériaux, la localisation et les contraintes du projet." },
    { title: "Travaux soignés", desc: "Les interventions sont préparées et réalisées avec attention, de la préparation du terrain jusqu’aux finitions extérieures." },
    { title: "Planning clair", desc: "Nous organisons les étapes du chantier afin de faciliter la coordination entre les différents intervenants." },
    { title: "Sécurité du chantier", desc: "La sécurité des personnes, des accès, des ouvrages existants et de l’environnement immédiat est prise en compte dans l’organisation des travaux." },
    { title: "Suivi du projet", desc: "Un accompagnement clair, de la première demande à la réalisation des travaux." },
];

export const PROJECTS = [
    {
        id: "p1",
        title: "Terrassement parking",
        category: "Terrassement",
        location: "Canton de Genève",
        image: "/rcps-assets/realisation-01-terrassement-parking.jpg",
        description:
            "Chantier de terrassement pour la création d’un parking dans le canton de Genève : préparation du terrain, décaissement et gestion des matériaux.",
    },
    {
        id: "p2",
        title: "Parking enrobé avec marquage",
        category: "Génie civil, voirie & enrobés",
        location: "Canton de Genève",
        image: "/rcps-assets/realisation-02-parking-enrobe-marquage.jpg",
        description:
            "Création d’un parking dans le canton de Genève : préparation des fonds, pose d’enrobé et marquage au sol.",
    },
    {
        id: "p3",
        title: "Aménagements extérieurs villa",
        category: "Aménagements extérieurs & enrochement",
        location: "Canton de Vaud",
        image: "/rcps-assets/realisation-03-amenagements-exterieurs-villa.jpg",
        description:
            "Aménagements extérieurs d’une villa dans le canton de Vaud : nivellement, accès et finitions extérieures.",
    },
    {
        id: "p4",
        title: "Aménagement extérieur particulier",
        category: "Aménagements extérieurs & enrochement",
        location: "Canton de Genève",
        image: "/rcps-assets/realisation-amenagement-exterieur-particulier-ge.jpg",
        description:
            "Aménagement extérieur pour un particulier dans le canton de Genève : préparation du terrain, nivellement, accès et finitions extérieures.",
    },
    {
        id: "p5",
        title: "Construction bâtiment collectif",
        category: "Terrassement",
        location: "Canton de Vaud",
        image: "/rcps-assets/realisation-batiment-collectif-vd.jpg",
        description:
            "Travaux de terrassement pour la construction d’un bâtiment collectif dans le canton de Vaud : fouilles, décaissement, gestion des matériaux et coordination avec les intervenants du chantier.",
    },
    {
        id: "p6",
        title: "Chantier enrobés particulier",
        category: "Génie civil, voirie & enrobés",
        location: "Canton de Vaud",
        image: "/rcps-assets/realisation-enrobes-particulier-vd.jpg",
        description:
            "Chantier d’enrobés pour un particulier dans le canton de Vaud : préparation des fonds, pose d’enrobé et finitions d’une surface extérieure.",
    },
    {
        id: "p7",
        title: "Construction d’une piscine",
        category: "Terrassement",
        location: "Canton de Vaud",
        image: "/rcps-assets/realisation-piscine-vd.jpg",
        description:
            "Terrassement et préparation du terrain pour la construction d’une piscine dans le canton de Vaud : excavation, gestion des niveaux et évacuation des terres.",
    },
];

export const REALISATION_CATEGORIES = [
    "Tous",
    "Terrassement",
    "Démolition & déconstruction",
    "Génie civil, voirie & enrobés",
    "Aménagements extérieurs & enrochement",
];

export const NAV_ITEMS = [
    { label: "Accueil", to: "/" },
    { label: "Entreprise", to: "/entreprise" },
    {
        label: "Prestations",
        to: "/prestations",
        children: [
            { label: "Terrassement", to: "/prestations/terrassement" },
            { label: "Démolition & déconstruction", to: "/prestations/demolition-deconstruction" },
            { label: "Génie civil, voirie & enrobés", to: "/prestations/genie-civil-voirie-enrobes" },
            { label: "Aménagements extérieurs & enrochement", to: "/prestations/amenagements-exterieurs-enrochement" },
        ],
    },
    { label: "Réalisations", to: "/realisations" },
    { label: "Contact", to: "/contact" },
];
